import { MasterTableClient, RoleClient } from "./ohl.virtualCenter.api";

const apiClient = new MasterTableClient(process.env.REACT_APP_PUBLIC_API);
const apiRoleClient = new RoleClient(process.env.REACT_APP_PUBLIC_API);
console.log('Using ' + process.env.REACT_APP_PUBLIC_API + ' route', process.env);

// DONE ----------------------
// provinces
// countries
// languajes
// likes

// client.type
// contact.type
// communication.device.type
// workingcenter
// activity.type
// professional.type
//
// TODO ----------------------
// monitoring.level
// activity.alert.criticality.type
// communication.company
// physical.status
// administration.type
// physical.cognitive.status
// activity.alert.type
// user.history.type

let provinces = null;
let provincesPromise = null;

let countries = null;
let countriesPromise = null;

let languajes = null;
let languajesPromise = null;

let clientLikes = null;
let clientLikesPromise = null;

let clientType = null;
let clientTypePromise = null;

let professionalType = null;
let professionalTypePromise = null;

let contactType = null;
let contactTypePromise = null;

let communicationDeviceType = null;
let communicationDeviceTypePromise = null;

let workingcenter = null;
let workingcenterPromise = null;

let gender = null;
let genderPromise = null;

let dependencyDegree = null;
let dependencyDegreePromise = null;

let therapeuticProfile = null;
let therapeuticProfilePromise = null;

let technologicalIndependence = null;
let technologicalIndependencePromise = null;

let usesTechHelp = null;
let usesTechHelpPromise = null;

let activityType = null;
let activityTypePromise = null;

let professionalRoles = null;
let professionalRolesPromise = null;

let baseportLocations = null;
let baseportLocationsPromise = null;

let aerialDeviceTypes = null;
let aerialDeviceTypesPromise = null;

let aerialResidentPetSize = null;
let aerialResidentPetSizePromise = null;

let aerialResidenceType = null;
let aerialResidenceTypePromise = null;

let civilStatus = null;
let civilStatusPromise = null;

let profession = null;
let professionPromise = null;

let communicationDevicesPlugModel = null;
let communicationDevicesPlugModelPromise = null;

let communicationDevicesBaseportModel = null;
let communicationDevicesBaseportModelPromise = null;

let communicationDevicesFirmwareModel = null;
let communicationDevicesFirmwareModelPromise = null;

let communicationDevicesTvboxModel = null;
let communicationDevicesTvboxModelPromise = null;

let communicationDevicesCameraModel = null;
let communicationDevicesCameraModelPromise = null;

let communicationDevicesRouterModel = null;
let communicationDevicesRouterModelPromise = null;

let communicationLineStatus = null;
let communicationLineStatusPromise = null;

let levelOfEducation = null;
let levelOfEducationPromise = null;

let typeOfStudies = null;
let typeOfStudiesPromise = null;

let culturalLevel = null;
let culturalLevelPromise = null;

let configuration = null;
let configurationPromise = null;

let configurationTypeValue = null;
let configurationTypeValuePromise = null;

let serviceModality = null;
let serviceModalityPromise = null;

let levelOfLoneliness = null;
let levelOfLonelinessPromise = null;

let sociodemographicEnvironment = null;
let sociodemographicEnvironmentPromise = null;

let causeOfWithdrawal = null;
let causeOfWithdrawalPromise = null;

let levelOfSocialization = null;
let levelOfSocializationPromise = null;

let reasonForCancellation = null;
let reasonForCancellationPromise = null;

let municipalityPEVS = null;
let municipalityPEVSPromise = null;

let cohabitant = null;
let cohabitantPromise = null;

let cognitiveDecline = null;
let cognitiveDeclinePromise = null;

let serviceType = null;
let serviceTypePromise = null;

let scaleStatus = null;
let scaleStatusPromise = null;

let scaleArea = null;
let scaleAreaPromise = null;

let objectiveStatus = null;
let objectiveStatusPromise = null;

export const getProvinces = () => {
    if (provinces) return new Promise((resolve, reject) => {
        resolve(provinces);
    });
    if (provincesPromise) return provincesPromise

    provincesPromise = new Promise((resolve, reject) => {
        apiClient.single({
            "type": "provinces",
            "subType": "108"
        })
            .then(
                res => {
                    provinces = res;
                    resolve(res);
                }
            ).catch(
                err => {
                    reject(err);
                }
            )
    })
    return provincesPromise;
}

export const getProvincesFilter = () => {
    if (provinces) return new Promise((resolve, reject) => {
        resolve(provinces);
    });
    if (provincesPromise) return provincesPromise

    provincesPromise = new Promise((resolve, reject) => {
        apiClient.single({
            "type": "provinces",
            "subType": "108"
        })
            .then(
                res => {
                    provinces = res;
                    resolve(res);
                }
            ).catch(
                err => {
                    reject(err);
                }
            )
    })
    return provincesPromise;
}


export const getCountries = () => {
    if (countries) return new Promise((resolve, reject) => {
        resolve(countries);
    });
    if (countriesPromise) return countriesPromise

    countriesPromise = new Promise((resolve, reject) => {
        apiClient.single({
            "type": "countries"
        })
            .then(
                res => {
                    countries = res;
                    resolve(res);
                }
            ).catch(
                err => {
                    reject(err);
                }
            )
    })
    return countriesPromise
}

export const getLanguajes = () => {
    if (languajes) return new Promise((resolve, reject) => {
        resolve(languajes);
    });
    if (languajesPromise) return languajesPromise

    languajesPromise = new Promise((resolve, reject) => {
        apiClient.single({
            "type": "languajes"
        })
            .then(
                res => {
                    languajes = res;
                    resolve(res);
                }
            ).catch(
                err => {
                    reject(err);
                }
            )
    })
    return languajesPromise
}

export const getLikes = () => {
    if (clientLikes) return new Promise((resolve, reject) => {
        resolve(clientLikes);
    });
    if (clientLikesPromise) return clientLikesPromise

    clientLikesPromise = new Promise((resolve, reject) => {
        apiClient.single({
            "type": "client.likes"
        })
            .then(
                res => {
                    clientLikes = res;
                    resolve(res);
                }
            ).catch(
                err => {
                    reject(err);
                }
            )
    })
    return clientLikesPromise
}

export const getClientType = () => {
    if (clientType) return new Promise((resolve, reject) => {
        resolve(clientType);
    });
    if (clientTypePromise) return clientTypePromise

    clientTypePromise = new Promise((resolve, reject) => {
        apiClient.single({
            "type": "client.type"
        })
            .then(
                res => {
                    clientType = res;
                    resolve(res);
                }
            ).catch(
                err => {
                    reject(err);
                }
            )
    })
    return clientTypePromise
}

export const getProfessionalType = () => {
    if (professionalType) return new Promise((resolve, reject) => {
        resolve(professionalType);
    });
    if (professionalTypePromise) return professionalTypePromise

    professionalTypePromise = new Promise((resolve, reject) => {
        apiClient.single({
            "type": "professional.type"
        })
            .then(
                res => {
                    professionalType = res;
                    resolve(res);
                }
            ).catch(
                err => {
                    reject(err);
                }
            )
    })
    return professionalTypePromise
}

export const getContactType = () => {
    if (contactType) return new Promise((resolve, reject) => {
        resolve(contactType);
    });
    if (contactTypePromise) return contactTypePromise

    contactTypePromise = new Promise((resolve, reject) => {
        apiClient.single({
            "type": "contact.type"
        })
            .then(
                res => {
                    contactType = res;
                    resolve(res);
                }
            ).catch(
                err => {
                    reject(err);
                }
            )
    })
    return contactTypePromise
}

export const getComunicationDeviceType = () => {
    if (communicationDeviceType) return new Promise((resolve, reject) => {
        resolve(communicationDeviceType);
    });
    if (communicationDeviceTypePromise) return communicationDeviceTypePromise

    communicationDeviceTypePromise = new Promise((resolve, reject) => {
        apiClient.single({
            "type": "communication.device.type"
        })
            .then(
                res => {
                    communicationDeviceType = res;
                    resolve(res);
                }
            ).catch(
                err => {
                    reject(err);
                }
            )
    })
    return communicationDeviceTypePromise;
}

export const getWorkingCenter = () => {
    if (workingcenter) return new Promise((resolve, reject) => {
        resolve(workingcenter);
    });
    if (workingcenterPromise) return workingcenterPromise

    workingcenterPromise = new Promise((resolve, reject) => {
        apiClient.single({
            "type": "workingcenter"
        })
            .then(
                res => {
                    workingcenter = res;
                    resolve(res);
                }
            ).catch(
                err => {
                    reject(err);
                }
            )
    })
    return workingcenterPromise
}

export const getGender = () => {
    if (gender) return new Promise((resolve, reject) => {
        resolve(gender);
    });
    if (genderPromise) return genderPromise

    genderPromise = new Promise((resolve, reject) => {
        apiClient.single({
            "type": "client.gender"
        })
            .then(
                res => {
                    gender = res;
                    resolve(res);
                }
            ).catch(
                err => {
                    reject(err);
                }
            )
    })
    return genderPromise
}

export const getDependencyDegree = () => {
    if (dependencyDegree) return new Promise((resolve, reject) => {
        resolve(dependencyDegree);
    });
    if (dependencyDegreePromise) return dependencyDegreePromise

    dependencyDegreePromise = new Promise((resolve, reject) => {
        apiClient.single({
            "type": "client.dependencyDegree"
        })
            .then(
                res => {
                    dependencyDegree = res;
                    resolve(res);
                }
            ).catch(
                err => {
                    reject(err);
                }
            )
    })
    return dependencyDegreePromise
}

export const getTherapeuticProfile = () => {
    if (therapeuticProfile) return new Promise((resolve, reject) => {
        resolve(therapeuticProfile);
    });
    if (therapeuticProfilePromise) return therapeuticProfilePromise

    therapeuticProfilePromise = new Promise((resolve, reject) => {
        apiClient.single({
            "type": "client.therapeuticProfile"
        })
            .then(
                res => {
                    therapeuticProfile = res;
                    resolve(res);
                }
            ).catch(
                err => {
                    reject(err);
                }
            )
    })
    return therapeuticProfilePromise
}

export const getTechnologicalIndependence = () => {
    if (technologicalIndependence) return new Promise((resolve, reject) => {
        resolve(technologicalIndependence);
    });
    if (technologicalIndependencePromise) return technologicalIndependencePromise

    technologicalIndependencePromise = new Promise((resolve, reject) => {
        apiClient.single({
            "type": "client.technologicalIndependence"
        })
            .then(
                res => {
                    technologicalIndependence = res;
                    resolve(res);
                }
            ).catch(
                err => {
                    reject(err);
                }
            )
    })
    return technologicalIndependencePromise
}

export const getUsesTechHelp = () => {
    if (usesTechHelp) return new Promise((resolve, reject) => {
        resolve(usesTechHelp);
    });
    if (usesTechHelpPromise) return usesTechHelpPromise

    usesTechHelpPromise = new Promise((resolve, reject) => {
        apiClient.single({
            "type": "client.usesTechHelp"
        })
            .then(
                res => {
                    usesTechHelp = res;
                    resolve(res);
                }
            ).catch(
                err => {
                    reject(err);
                }
            )
    })
    return usesTechHelpPromise
}

export const getActivityType = () => {
    if (activityType) return new Promise((resolve, reject) => {
        resolve(activityType);
    });
    if (activityTypePromise) return activityTypePromise

    activityTypePromise = new Promise((resolve, reject) => {
        apiClient.single({
            "type": "activity.type"
        })
            .then(
                res => {
                    activityType = res;
                    resolve(res);
                }
            ).catch(
                err => {
                    reject(err);
                }
            )
    })
    return activityTypePromise;
}

export const getActivityTypeValue = (subtype) => {
    return apiClient.single({
        "type": "activity.typeValue",
        "subType": subtype
    })
}

export const getProfessionalRoles = () => {
    if (professionalRoles) return new Promise((resolve, reject) => {
        resolve(professionalRoles);
    });
    if (professionalRolesPromise) return professionalRolesPromise

    professionalRolesPromise = new Promise((resolve, reject) => {
        apiRoleClient.professionals()
            .then(
                res => {
                    professionalRoles = res;
                    resolve(res);
                }
            ).catch(
                err => {
                    reject(err);
                }
            )
    })
    return professionalRolesPromise
}

export const getBaseportLocations = () => {
    if (baseportLocations) return new Promise((resolve, reject) => {
        resolve(baseportLocations);
    });
    if (baseportLocationsPromise) return baseportLocationsPromise

    baseportLocationsPromise = new Promise((resolve, reject) => {
        apiClient.single({
            "type": "aerial.location"
        })
            .then(
                res => {
                    baseportLocations = res;
                    resolve(res);
                }
            ).catch(
                err => {
                    reject(err);
                }
            )
    })
    return baseportLocationsPromise;
}

export const getAerialDeviceTypes = () => {
    if (aerialDeviceTypes) return new Promise((resolve, reject) => {
        resolve(aerialDeviceTypes);
    });
    if (aerialDeviceTypesPromise) return aerialDeviceTypesPromise

    aerialDeviceTypesPromise = new Promise((resolve, reject) => {
        apiClient.single({
            "type": "aerial.deviceType"
        })
            .then(
                res => {
                    aerialDeviceTypes = res;
                    resolve(res);
                }
            ).catch(
                err => {
                    reject(err);
                }
            )
    })
    return aerialDeviceTypesPromise;
}

export const getAerialResidentPetSize = () => {
    if (aerialResidentPetSize) return new Promise((resolve, reject) => {
        resolve(aerialResidentPetSize);
    });
    if (aerialResidentPetSizePromise) return aerialResidentPetSizePromise

    aerialResidentPetSizePromise = new Promise((resolve, reject) => {
        apiClient.single({
            "type": "aerial.residentPetSize"
        })
            .then(
                res => {
                    aerialResidentPetSize = res;
                    resolve(res);
                }
            ).catch(
                err => {
                    reject(err);
                }
            )
    })
    return aerialResidentPetSizePromise;
}

export const getAerialResidenceType = () => {
    if (aerialResidenceType) return new Promise((resolve, reject) => {
        resolve(aerialResidenceType);
    });
    if (aerialResidenceTypePromise) return aerialResidenceTypePromise

    aerialResidenceTypePromise = new Promise((resolve, reject) => {
        apiClient.single({
            "type": "aerial.residenceType"
        })
            .then(
                res => {
                    aerialResidenceType = res;
                    resolve(res);
                }
            ).catch(
                err => {
                    reject(err);
                }
            )
    })
    return aerialResidenceTypePromise;
}



export const getCivilStatus = () => {
    if (civilStatus) return new Promise((resolve, reject) => {
        resolve(civilStatus);
    });
    if (civilStatusPromise) return civilStatusPromise

    civilStatusPromise = new Promise((resolve, reject) => {
        apiClient.single({
            "type": "client.civilStatus"
        })
            .then(
                res => {
                    civilStatus = res;
                    resolve(res);
                }
            ).catch(
                err => {
                    reject(err);
                }
            )
    })
    return civilStatusPromise
}

export const getProfession = () => {
    if (profession) return new Promise((resolve, reject) => {
        resolve(profession);
    });
    if (professionPromise) return professionPromise

    professionPromise = new Promise((resolve, reject) => {
        apiClient.single({
            "type": "client.profession"
        })
            .then(
                res => {
                    profession = res;
                    resolve(res);
                }
            ).catch(
                err => {
                    reject(err);
                }
            )
    })
    return professionPromise
}

export const getCommunicationDevicesPlugModel = () => {
    if (communicationDevicesPlugModel) return new Promise((resolve, reject) => {
        resolve(communicationDevicesPlugModel);
    });
    if (communicationDevicesPlugModelPromise) return communicationDevicesPlugModelPromise

    communicationDevicesPlugModelPromise = new Promise((resolve, reject) => {
        apiClient.single({
            "type": "communicationDevices.plugModel"
        })
            .then(
                res => {
                    communicationDevicesPlugModel = res;
                    resolve(res);
                }
            ).catch(
                err => {
                    reject(err);
                }
            )
    })
    return communicationDevicesPlugModelPromise
}

export const getCommunicationDevicesBaseportModel = () => {
    if (communicationDevicesBaseportModel) return new Promise((resolve, reject) => {
        resolve(communicationDevicesBaseportModel);
    });
    if (communicationDevicesBaseportModelPromise) return communicationDevicesBaseportModelPromise

    communicationDevicesBaseportModelPromise = new Promise((resolve, reject) => {
        apiClient.single({
            "type": "communicationDevices.baseportModel"
        })
            .then(
                res => {
                    communicationDevicesBaseportModel = res;
                    resolve(res);
                }
            ).catch(
                err => {
                    reject(err);
                }
            )
    })
    return communicationDevicesBaseportModelPromise
}

export const getCommunicationDevicesFirmwareModel = () => {
    if (communicationDevicesFirmwareModel) return new Promise((resolve, reject) => {
        resolve(communicationDevicesFirmwareModel);
    });
    if (communicationDevicesFirmwareModelPromise) return communicationDevicesFirmwareModelPromise

    communicationDevicesFirmwareModelPromise = new Promise((resolve, reject) => {
        apiClient.single({
            "type": "communicationDevices.firmwareModel"
        })
            .then(
                res => {
                    communicationDevicesFirmwareModel = res;
                    resolve(res);
                }
            ).catch(
                err => {
                    reject(err);
                }
            )
    })
    return communicationDevicesFirmwareModelPromise
}

export const getCommunicationDevicesTvboxModel = () => {
    if (communicationDevicesTvboxModel) return new Promise((resolve, reject) => {
        resolve(communicationDevicesTvboxModel);
    });
    if (communicationDevicesTvboxModelPromise) return communicationDevicesTvboxModelPromise

    communicationDevicesTvboxModelPromise = new Promise((resolve, reject) => {
        apiClient.single({
            "type": "communicationDevices.tvboxModel"
        })
            .then(
                res => {
                    communicationDevicesTvboxModel = res;
                    resolve(res);
                }
            ).catch(
                err => {
                    reject(err);
                }
            )
    })
    return communicationDevicesTvboxModelPromise
}

export const getCommunicationDevicesCameraModel = () => {
    if (communicationDevicesCameraModel) return new Promise((resolve, reject) => {
        resolve(communicationDevicesCameraModel);
    });
    if (communicationDevicesCameraModelPromise) return communicationDevicesCameraModelPromise

    communicationDevicesCameraModelPromise = new Promise((resolve, reject) => {
        apiClient.single({
            "type": "communicationDevices.cameraModel"
        })
            .then(
                res => {
                    communicationDevicesCameraModel = res;
                    resolve(res);
                }
            ).catch(
                err => {
                    reject(err);
                }
            )
    })
    return communicationDevicesCameraModelPromise
}

export const getCommunicationDevicesRouterModel = () => {
    if (communicationDevicesRouterModel) return new Promise((resolve, reject) => {
        resolve(communicationDevicesRouterModel);
    });
    if (communicationDevicesRouterModelPromise) return communicationDevicesRouterModelPromise

    communicationDevicesRouterModelPromise = new Promise((resolve, reject) => {
        apiClient.single({
            "type": "communicationDevices.routerModel"
        })
            .then(
                res => {
                    communicationDevicesRouterModel = res;
                    resolve(res);
                }
            ).catch(
                err => {
                    reject(err);
                }
            )
    })
    return communicationDevicesRouterModelPromise
}


export const getCommunicationLineStatus = () => {
    if (communicationLineStatus) return new Promise((resolve, reject) => {
        resolve(communicationLineStatus);
    });
    if (communicationLineStatusPromise) return communicationLineStatusPromise

    communicationLineStatusPromise = new Promise((resolve, reject) => {
        apiClient.single({
            "type": "communicationDevices.lineStatus"
        })
            .then(
                res => {
                    communicationLineStatus = res;
                    resolve(res);
                }
            ).catch(
                err => {
                    reject(err);
                }
            )
    })
    return communicationLineStatusPromise
}

export const getLevelOfEducation = () => {
    if (levelOfEducation) return new Promise((resolve, reject) => {
        resolve(levelOfEducation);
    });
    if (levelOfEducationPromise) return levelOfEducationPromise

    levelOfEducationPromise = new Promise((resolve, reject) => {
        apiClient.single({
            "type": "client.levelOfEducation"
        })
            .then(
                res => {
                    levelOfEducation = res;
                    resolve(res);
                }
            ).catch(
                err => {
                    reject(err);
                }
            )
    })
    return levelOfEducationPromise
}


export const getTypeOfStudies = () => {
    if (typeOfStudies) return new Promise((resolve, reject) => {
        resolve(typeOfStudies);
    });
    if (typeOfStudiesPromise) return typeOfStudiesPromise

    typeOfStudiesPromise = new Promise((resolve, reject) => {
        apiClient.single({
            "type": "client.typeOfStudies"
        })
            .then(
                res => {
                    typeOfStudies = res;
                    resolve(res);
                }
            ).catch(
                err => {
                    reject(err);
                }
            )
    })
    return typeOfStudiesPromise
}


export const getCulturalLevel = () => {
    if (culturalLevel) return new Promise((resolve, reject) => {
        resolve(culturalLevel);
    });
    if (culturalLevelPromise) return culturalLevelPromise

    culturalLevelPromise = new Promise((resolve, reject) => {
        apiClient.single({
            "type": "client.culturalLevel"
        })
            .then(
                res => {
                    culturalLevel = res;
                    resolve(res);
                }
            ).catch(
                err => {
                    reject(err);
                }
            )
    })
    return culturalLevelPromise
}


export const getConfiguration = () => {
    if (configuration) return new Promise((resolve, reject) => {
        resolve(configuration);
    });
    if (configurationPromise) return configurationPromise

    configurationPromise = new Promise((resolve, reject) => {
        apiClient.single({
            "type": "configuration.type"
        })
            .then(
                res => {
                    configuration = res;
                    resolve(res);
                }
            ).catch(
                err => {
                    reject(err);
                }
            )
    })
    return configurationPromise
}


export const getConfigurationTypeValue = () => {
    if (configurationTypeValue) return new Promise((resolve, reject) => {
        resolve(configurationTypeValue);
    });
    if (configurationTypeValuePromise) return configurationTypeValuePromise

    configurationTypeValuePromise = new Promise((resolve, reject) => {
        apiClient.single({
            "type": "configuration.typeValue"
        })
            .then(
                res => {
                    configurationTypeValue = res;
                    resolve(res);
                }
            ).catch(
                err => {
                    reject(err);
                }
            )
    })
    return configurationTypeValuePromise
}

export const getServiceModality = () => {
    if (serviceModality) return new Promise((resolve, reject) => {
        resolve(serviceModality);
    });
    if (serviceModalityPromise) return serviceModalityPromise

    serviceModalityPromise = new Promise((resolve, reject) => {
        apiClient.single({
            "type": "client.serviceModality"
        })
            .then(
                res => {
                    serviceModality = res;
                    resolve(res);
                }
            ).catch(
                err => {
                    reject(err);
                }
            )
    })
    return serviceModalityPromise
}

export const getLevelOfLoneliness = () => {
    if (levelOfLoneliness) return new Promise((resolve, reject) => {
        resolve(levelOfLoneliness);
    });
    if (levelOfLonelinessPromise) return levelOfLonelinessPromise

    levelOfLonelinessPromise = new Promise((resolve, reject) => {
        apiClient.single({
            "type": "client.levelOfLoneliness"
        })
            .then(
                res => {
                    levelOfLoneliness = res;
                    resolve(res);
                }
            ).catch(
                err => {
                    reject(err);
                }
            )
    })
    return levelOfLonelinessPromise
}

export const getSociodemographicEnvironment = () => {
    if (sociodemographicEnvironment) return new Promise((resolve, reject) => {
        resolve(sociodemographicEnvironment);
    });
    if (sociodemographicEnvironmentPromise) return sociodemographicEnvironmentPromise

    sociodemographicEnvironmentPromise = new Promise((resolve, reject) => {
        apiClient.single({
            "type": "client.sociodemographicEnvironment"
        })
            .then(
                res => {
                    sociodemographicEnvironment = res;
                    resolve(res);
                }
            ).catch(
                err => {
                    reject(err);
                }
            )
    })
    return sociodemographicEnvironmentPromise
}

export const getCauseOfWithdrawal = () => {
    if (causeOfWithdrawal) return new Promise((resolve, reject) => {
        resolve(causeOfWithdrawal);
    });
    if (causeOfWithdrawalPromise) return causeOfWithdrawalPromise

    causeOfWithdrawalPromise = new Promise((resolve, reject) => {
        apiClient.single({
            "type": "client.causeOfWithdrawal"
        })
            .then(
                res => {
                    causeOfWithdrawal = res;
                    resolve(res);
                }
            ).catch(
                err => {
                    reject(err);
                }
            )
    })
    return causeOfWithdrawalPromise
}

export const getLevelOfSocialization = () => {
    if (levelOfSocialization) return new Promise((resolve, reject) => {
        resolve(levelOfSocialization);
    });
    if (levelOfSocializationPromise) return levelOfSocializationPromise

    levelOfSocializationPromise = new Promise((resolve, reject) => {
        apiClient.single({
            "type": "client.levelOfSocialization"
        })
            .then(
                res => {
                    levelOfSocialization = res;
                    resolve(res);
                }
            ).catch(
                err => {
                    reject(err);
                }
            )
    })
    return levelOfSocializationPromise
}


export const getReasonForCancellation = () => {
    if (reasonForCancellation) return new Promise((resolve, reject) => {
        resolve(reasonForCancellation);
    });
    if (reasonForCancellationPromise) return reasonForCancellationPromise

    reasonForCancellationPromise = new Promise((resolve, reject) => {
        apiClient.single({
            "type": "scheduledActivity.reasonForCancellation"
        })
            .then(
                res => {
                    reasonForCancellation = res;
                    resolve(res);
                }
            ).catch(
                err => {
                    reject(err);
                }
            )
    })
    return reasonForCancellationPromise
}

export const getMunicipalityPEVS = () => {
    if (municipalityPEVS) return new Promise((resolve, reject) => {
        resolve(municipalityPEVS);
    });
    if (municipalityPEVSPromise) return municipalityPEVSPromise

    municipalityPEVSPromise = new Promise((resolve, reject) => {
        apiClient.single({
            "type": "client.municipalityPEVS"
        })
            .then(
                res => {
                    municipalityPEVS = res;
                    resolve(res);
                }
            ).catch(
                err => {
                    reject(err);
                }
            )
    })
    return municipalityPEVSPromise
}

export const getCohabitant = () => {
    if (cohabitant) return new Promise((resolve, reject) => {
        resolve(cohabitant);
    });
    if (cohabitantPromise) return cohabitantPromise

    cohabitantPromise = new Promise((resolve, reject) => {
        apiClient.single({
            "type": "client.cohabitant"
        })
            .then(
                res => {
                    cohabitant = res;
                    resolve(res);
                }
            ).catch(
                err => {
                    reject(err);
                }
            )
    })
    return cohabitantPromise
}

export const getCognitiveDecline = () => {
    if (cognitiveDecline) return new Promise((resolve, reject) => {
        resolve(cognitiveDecline);
    });
    if (cognitiveDeclinePromise) return cognitiveDeclinePromise

    cognitiveDeclinePromise = new Promise((resolve, reject) => {
        apiClient.single({
            "type": "client.cognitiveDecline"
        })
            .then(
                res => {
                    cognitiveDecline = res;
                    resolve(res);
                }
            ).catch(
                err => {
                    reject(err);
                }
            )
    })
    return cognitiveDeclinePromise
}

export const getServiceType = () => {
    if (serviceType) return new Promise((resolve, reject) => {
        resolve(serviceType);
    });
    if (serviceTypePromise) return serviceTypePromise

    serviceTypePromise = new Promise((resolve, reject) => {
        apiClient.single({
            "type": "servicePackages.serviceType"
        })
            .then(
                res => {
                    serviceType = res;
                    resolve(res);
                }
            ).catch(
                err => {
                    reject(err);
                }
            )
    })
    return serviceTypePromise
}

export const getScaleStatus = () => {
    if (scaleStatus) return new Promise((resolve, reject) => {
        resolve(scaleStatus);
    });
    if (scaleStatusPromise) return scaleStatusPromise

    scaleStatusPromise = new Promise((resolve, reject) => {
        apiClient.single({
            "type": "scaleRegisters.scaleStatus"
        })
            .then(
                res => {
                    serviceType = res;
                    resolve(res);
                }
            ).catch(
                err => {
                    reject(err);
                }
            )
    })
    return scaleStatusPromise
}

export const getArea = () => {
    if (scaleArea) return new Promise((resolve, reject) => {
        resolve(scaleArea);
    });
    if (scaleAreaPromise) return scaleAreaPromise

    scaleAreaPromise = new Promise((resolve, reject) => {
        apiClient.single({
            "type": "scale.area"
        })
            .then(
                res => {
                    serviceType = res;
                    resolve(res);
                }
            ).catch(
                err => {
                    reject(err);
                }
            )
    })
    return scaleAreaPromise
}


export const getObjectiveStatus = () => {
    if (objectiveStatus) {
        return Promise.resolve(objectiveStatus);
    }

    if (objectiveStatusPromise) {
        return objectiveStatusPromise;
    }

    // Creamos la promesa y la guardamos
    objectiveStatusPromise = apiClient
        .single({ type: "scaleObjectives.objectiveStatus" })
        .then(res => {
            objectiveStatus = res;     
            return res;
        })
        .catch(err => {
            objectiveStatusPromise = null; 
            throw err;
        });

    return objectiveStatusPromise;  
};



export const resetCache = (masterTableTypeArray) => {
    masterTableTypeArray.forEach(element => {
        console.log('Clear cache ' + element)
        switch (element) {
            case 'client.likes':
                clientLikes = null;
                clientLikesPromise = null;
                break;
            case 'workingcenter':
                workingcenter = null;
                workingcenterPromise = null;
                break;

            default:
                break;
        }
    });
}